import { CONTENT_BLOCK_TYPES, getContentBlockConfig, getContentBlockSampleData } from "../../../../components/EmailEditor/constants/contentBlockConstants";

/**
 * 生成内容块示例HTML的函数
 * @param {string} blockType - 内容块类型
 * @param {object} config - 内容块配置
 * @returns {string} 生成的示例HTML
 */
export const generateSampleContentBlock = (blockType, config) => {
    const sampleData = getContentBlockSampleData(blockType);

    switch (blockType) {
        case CONTENT_BLOCK_TYPES.FLIGHT_INFO:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #1890ff; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <table style="width: 100%; border-collapse: collapse;">
                        <tr><td style="padding: 4px 8px; font-weight: bold; width: 80px;">航班号:</td><td style="padding: 4px 8px;">${sampleData.flightNumber}</td></tr>
                        <tr><td style="padding: 4px 8px; font-weight: bold;">机型:</td><td style="padding: 4px 8px;">${sampleData.aircraft}</td></tr>
                        <tr><td style="padding: 4px 8px; font-weight: bold;">航线:</td><td style="padding: 4px 8px;">${sampleData.route}</td></tr>
                        <tr><td style="padding: 4px 8px; font-weight: bold;">起飞:</td><td style="padding: 4px 8px;">${sampleData.departureTime}</td></tr>
                        <tr><td style="padding: 4px 8px; font-weight: bold;">到达:</td><td style="padding: 4px 8px;">${sampleData.arrivalTime}</td></tr>
                        <tr><td style="padding: 4px 8px; font-weight: bold;">登机口:</td><td style="padding: 4px 8px;">${sampleData.gate}</td></tr>
                        <tr><td style="padding: 4px 8px; font-weight: bold;">状态:</td><td style="padding: 4px 8px; color: #52c41a;">${sampleData.status}</td></tr>
                    </table>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.FLIGHT_LIST:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #1890ff; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <table style="width: 100%; border-collapse: collapse; border: 1px solid #d9d9d9;">
                        <thead>
                            <tr style="background: #f5f5f5;">
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">航班号</th>
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">航线</th>
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">起飞时间</th>
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">状态</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${sampleData
                                .map(
                                    (flight) => `
                                <tr>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${flight.flightNumber}</td>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${flight.route}</td>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${flight.departureTime}</td>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px; color: ${flight.status === "准时" ? "#52c41a" : "#ff4d4f"};">${flight.status}</td>
                                </tr>
                            `,
                                )
                                .join("")}
                        </tbody>
                    </table>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.CONTACT:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #722ed1; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <p style="margin: 4px 0;"><strong>姓名:</strong> ${sampleData.name}</p>
                    <p style="margin: 4px 0;"><strong>职位:</strong> ${sampleData.position}</p>
                    <p style="margin: 4px 0;"><strong>电话:</strong> <a href="tel:${sampleData.phone}">${sampleData.phone}</a></p>
                    <p style="margin: 4px 0;"><strong>邮箱:</strong> <a href="mailto:${sampleData.email}">${sampleData.email}</a></p>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.ATTACHMENT:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #52c41a; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <div style="display: flex; align-items: center; padding: 8px; border: 1px solid #d9d9d9; border-radius: 4px; background: white;">
                        <span style="margin-right: 12px; font-size: 24px;">📄</span>
                        <div>
                            <div style="font-weight: bold; color: #1890ff;">${sampleData.fileName}</div>
                            <div style="font-size: 12px; color: #666;">${sampleData.fileSize} • ${sampleData.uploadTime}</div>
                        </div>
                    </div>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.CARGO_MANIFEST:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #fa8c16; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
                        <p style="margin: 4px 0;"><strong>总重量:</strong> ${sampleData.totalWeight}</p>
                        <p style="margin: 4px 0;"><strong>总体积:</strong> ${sampleData.totalVolume}</p>
                        <p style="margin: 4px 0;"><strong>包裹数:</strong> ${sampleData.packages}</p>
                        <p style="margin: 4px 0;"><strong>特殊货物:</strong> ${sampleData.specialCargo}</p>
                    </div>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.CREW_INFO:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #13c2c2; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <p style="margin: 4px 0;"><strong>机长:</strong> ${sampleData.captain}</p>
                    <p style="margin: 4px 0;"><strong>副驾驶:</strong> ${sampleData.firstOfficer}</p>
                    <p style="margin: 4px 0;"><strong>乘务长:</strong> ${sampleData.cabinManager}</p>
                    <p style="margin: 4px 0;"><strong>乘务员:</strong> ${sampleData.flightAttendants.join("、")}</p>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.AIRPORT_INFO:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #eb2f96; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <p style="margin: 4px 0;"><strong>机场代码:</strong> ${sampleData.code}</p>
                    <p style="margin: 4px 0;"><strong>机场名称:</strong> ${sampleData.name}</p>
                    <p style="margin: 4px 0;"><strong>天气:</strong> ${sampleData.weather}</p>
                    <p style="margin: 4px 0;"><strong>能见度:</strong> ${sampleData.visibility}</p>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.FLIGHT_SCHEDULE:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #1890ff; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
                        <p style="margin: 4px 0;"><strong>计划周期:</strong> ${sampleData.period}</p>
                        <p style="margin: 4px 0;"><strong>总航班数:</strong> ${sampleData.totalFlights}</p>
                        <p style="margin: 4px 0;"><strong>准点率:</strong> ${sampleData.onTimeRate}</p>
                        <p style="margin: 4px 0;"><strong>平均延误:</strong> ${sampleData.averageDelay}</p>
                    </div>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.CONTACT_LIST:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #722ed1; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <table style="width: 100%; border-collapse: collapse; border: 1px solid #d9d9d9;">
                        <thead>
                            <tr style="background: #f5f5f5;">
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">姓名</th>
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">职位</th>
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">电话</th>
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">邮箱</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${sampleData
                                .map(
                                    (contact) => `
                                <tr>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${contact.name}</td>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${contact.position}</td>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;"><a href="tel:${contact.phone}">${contact.phone}</a></td>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;"><a href="mailto:${contact.email}">${contact.email}</a></td>
                                </tr>
                            `,
                                )
                                .join("")}
                        </tbody>
                    </table>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.ATTACHMENT_LIST:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #52c41a; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <div style="display: flex; flex-direction: column; gap: 8px;">
                        ${sampleData
                            .map(
                                (attachment) => `
                            <div style="display: flex; align-items: center; padding: 8px; border: 1px solid #d9d9d9; border-radius: 4px; background: white;">
                                <span style="margin-right: 12px; font-size: 20px;">📄</span>
                                <div style="flex: 1;">
                                    <div style="font-weight: bold; color: #1890ff;">${attachment.fileName}</div>
                                    <div style="font-size: 12px; color: #666;">${attachment.fileSize} • ${attachment.uploadTime}</div>
                                </div>
                            </div>
                        `,
                            )
                            .join("")}
                    </div>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.CARGO_LIST:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #fa8c16; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <table style="width: 100%; border-collapse: collapse; border: 1px solid #d9d9d9;">
                        <thead>
                            <tr style="background: #f5f5f5;">
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">货物名称</th>
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">重量</th>
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">体积</th>
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">类型</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${sampleData
                                .map(
                                    (cargo) => `
                                <tr>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${cargo.name}</td>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${cargo.weight}</td>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${cargo.volume}</td>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${cargo.type}</td>
                                </tr>
                            `,
                                )
                                .join("")}
                        </tbody>
                    </table>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.CREW_LIST:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #13c2c2; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <table style="width: 100%; border-collapse: collapse; border: 1px solid #d9d9d9;">
                        <thead>
                            <tr style="background: #f5f5f5;">
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">姓名</th>
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">职位</th>
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">工号</th>
                                <th style="border: 1px solid #d9d9d9; padding: 8px; text-align: left;">联系方式</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${sampleData
                                .map(
                                    (crew) => `
                                <tr>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${crew.name}</td>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${crew.position}</td>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${crew.employeeId}</td>
                                    <td style="border: 1px solid #d9d9d9; padding: 8px;">${crew.contact}</td>
                                </tr>
                            `,
                                )
                                .join("")}
                        </tbody>
                    </table>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.FUEL_INFO:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #ff4d4f; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
                        <p style="margin: 4px 0;"><strong>申请燃油:</strong> ${sampleData.requestedFuel}</p>
                        <p style="margin: 4px 0;"><strong>燃油类型:</strong> ${sampleData.fuelType}</p>
                        <p style="margin: 4px 0;"><strong>供应商:</strong> ${sampleData.supplier}</p>
                        <p style="margin: 4px 0;"><strong>预估费用:</strong> ${sampleData.estimatedCost}</p>
                        <p style="margin: 4px 0;"><strong>交付时间:</strong> ${sampleData.deliveryTime}</p>
                        <p style="margin: 4px 0;"><strong>联系人:</strong> ${sampleData.contactPerson}</p>
                    </div>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.FUEL_REQUEST:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #ff4d4f; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
                        <p style="margin: 4px 0;"><strong>申请编号:</strong> ${sampleData.requestId}</p>
                        <p style="margin: 4px 0;"><strong>申请状态:</strong> <span style="color: #52c41a;">${sampleData.status}</span></p>
                        <p style="margin: 4px 0;"><strong>申请时间:</strong> ${sampleData.requestTime}</p>
                        <p style="margin: 4px 0;"><strong>预计完成:</strong> ${sampleData.expectedCompletion}</p>
                        <p style="margin: 4px 0;"><strong>申请人:</strong> ${sampleData.requestedBy}</p>
                        <p style="margin: 4px 0;"><strong>审批人:</strong> ${sampleData.approvedBy}</p>
                    </div>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.DATETIME:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #1890ff; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <p style="margin: 4px 0;"><strong>当前时间:</strong> ${sampleData.currentTime}</p>
                    <p style="margin: 4px 0;"><strong>时区:</strong> ${sampleData.timezone}</p>
                    <p style="margin: 4px 0;"><strong>UTC时间:</strong> ${sampleData.utcTime}</p>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.SCHEDULE_PERIOD:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #722ed1; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <p style="margin: 4px 0;"><strong>计划周期:</strong> ${sampleData.period}</p>
                    <p style="margin: 4px 0;"><strong>开始日期:</strong> ${sampleData.startDate}</p>
                    <p style="margin: 4px 0;"><strong>结束日期:</strong> ${sampleData.endDate}</p>
                    <p style="margin: 4px 0;"><strong>总天数:</strong> ${sampleData.totalDays}</p>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.SIGNATURE:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #13c2c2; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <div style="border-top: 1px solid #d9d9d9; padding-top: 12px; margin-top: 12px;">
                        <p style="margin: 4px 0;"><strong>${sampleData.name}</strong></p>
                        <p style="margin: 4px 0; color: #666;">${sampleData.title}</p>
                        <p style="margin: 4px 0; color: #666;">${sampleData.department}</p>
                        <p style="margin: 4px 0; color: #666;">电话: ${sampleData.phone} | 邮箱: ${sampleData.email}</p>
                    </div>
                </div>
            `;

        case CONTENT_BLOCK_TYPES.CONTENT_BLOCK:
            return `
                <div style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fafafa;">
                    <h4 style="margin: 0 0 12px 0; color: #fa8c16; display: flex; align-items: center;">
                        <span style="margin-right: 8px;">${config.icon}</span>
                        ${config.label}
                    </h4>
                    <div style="padding: 12px; background: white; border-radius: 4px;">
                        <p style="margin: 0; color: #666;">${sampleData.content}</p>
                    </div>
                </div>
            `;

        default:
            // 对于未知的内容块类型，返回一个通用的占位符
            return `
                <div style="border: 1px solid #ff4d4f; border-radius: 6px; padding: 16px; margin: 8px 0; background: #fff2f0;">
                    <h4 style="margin: 0 0 12px 0; color: #ff4d4f;">
                        未知内容块类型: ${blockType}
                    </h4>
                    <p style="margin: 0; color: #666;">请检查内容块类型是否正确配置</p>
                </div>
            `;
    }
};

/**
 * 处理HTML内容，将内容块替换为示例数据
 * @param {string} html - 原始HTML内容
 * @returns {string} 处理后的HTML内容
 */
export const processHtmlWithSampleData = (html) => {
    if (!html) return html;

    // 使用正则表达式找到所有的内容块 (支持 div 和 span 标签)
    // 使用[\s\S]匹配包括换行符在内的所有字符
    return html
        .replace(/<div[^>]*data-content-block-type="([^"]+)"[^>]*>[\s\S]*?<\/div>/g, (match, blockType) => {
            const config = getContentBlockConfig(blockType);
            return generateSampleContentBlock(blockType, config);
        })
        .replace(/<span[^>]*data-content-block-type="([^"]+)"[^>]*>[\s\S]*?<\/span>/g, (match, blockType) => {
            const config = getContentBlockConfig(blockType);
            // 对于行内内容块，生成简化的示例内容
            return generateInlineSampleContentBlock(blockType, config);
        });
};

/**
 * 生成行内内容块的简化示例内容
 * @param {string} blockType - 内容块类型
 * @param {object} config - 内容块配置
 * @returns {string} 生成的行内示例内容
 */
export const generateInlineSampleContentBlock = (blockType, config) => {
    const sampleData = getContentBlockSampleData(blockType);

    switch (blockType) {
        case CONTENT_BLOCK_TYPES.FLIGHT_INFO:
            return `<span style="background: #e6f7ff; padding: 2px 6px; border-radius: 3px; color: #1890ff; font-weight: 500;">${sampleData.flightNumber}</span>`;

        case CONTENT_BLOCK_TYPES.CONTACT:
            return `<span style="background: #f9f0ff; padding: 2px 6px; border-radius: 3px; color: #722ed1; font-weight: 500;">${sampleData.name}</span>`;

        case CONTENT_BLOCK_TYPES.SCHEDULE_INFO:
            return `<span style="background: #f6ffed; padding: 2px 6px; border-radius: 3px; color: #52c41a; font-weight: 500;">${sampleData.name}</span>`;

        case CONTENT_BLOCK_TYPES.DATETIME:
            return `<span style="background: #e6f7ff; padding: 2px 6px; border-radius: 3px; color: #1890ff; font-weight: 500;">${sampleData.currentTime}</span>`;

        case CONTENT_BLOCK_TYPES.SIGNATURE:
            return `<span style="background: #e6fffb; padding: 2px 6px; border-radius: 3px; color: #13c2c2; font-weight: 500;">${sampleData.name}</span>`;

        case CONTENT_BLOCK_TYPES.AIRPORT_INFO:
            return `<span style="background: #fff0f6; padding: 2px 6px; border-radius: 3px; color: #eb2f96; font-weight: 500;">${sampleData.code}</span>`;

        case CONTENT_BLOCK_TYPES.FUEL_INFO:
            return `<span style="background: #fff2e8; padding: 2px 6px; border-radius: 3px; color: #fa8c16; font-weight: 500;">${sampleData.requestedFuel}</span>`;

        case CONTENT_BLOCK_TYPES.CREW_INFO:
            return `<span style="background: #e6fffb; padding: 2px 6px; border-radius: 3px; color: #13c2c2; font-weight: 500;">${sampleData.captain}</span>`;

        case CONTENT_BLOCK_TYPES.CONTENT_BLOCK:
            return `<span style="background: #fff7e6; padding: 2px 6px; border-radius: 3px; color: #fa8c16; font-weight: 500;">${config.label}</span>`;

        default:
            // 对于未知的内容块类型，返回一个通用的行内占位符
            return `<span style="background: #fff1f0; padding: 2px 6px; border-radius: 3px; color: #ff4d4f; font-weight: 500;">${blockType}</span>`;
    }
};
